// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"QuestionDefinitionsCloseButton__closeButton___32CZ6","closeIcon":"QuestionDefinitionsCloseButton__closeIcon___2CDQT"};